import { useState, useEffect, useMemo, useCallback } from 'react';
// eslint-disable-next-line jira/restricted/@atlassiansox+engagekit-ts
import { CoordinationClient } from '@atlassiansox/engagekit-ts';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';

const NO_CONTENT = 204;

const CONFLICT = 409;

// @ts-expect-error - TS2415 - Class 'CustomCoordinationClient' incorrectly extends base class 'CoordinationClient'. Property 'cloudId' is private in type 'CoordinationClient' but not in type 'CustomCoordinationClient'.
class CustomCoordinationClient extends CoordinationClient {
	cloudId: string;

	stargateUrl: string;

	notEnrolledMessages: string[] = [];

	orgId: string;

	constructor(cloudId: string, stargateUrl: string, orgId: string) {
		super({ cloudId, stargateUrl, orgId, isFedRAMPEnvironment: false });
		this.cloudId = cloudId;
		this.orgId = orgId;
		this.stargateUrl = stargateUrl;
	}

	async start(messageId: string): Promise<boolean> {
		const requestBody = {
			cloudId: this.cloudId,
			orgId: this.orgId,
		};
		return fetch(`${this.stargateUrl}/engage-targeting/api/v2/user/messages/${messageId}/start`, {
			method: 'post',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(requestBody),
		}).then(async (response) => {
			if (response.status === CONFLICT) {
				const responseText = await response.text();
				if (responseText?.toLowerCase().includes('user is not enrolled in message')) {
					this.notEnrolledMessages.push(messageId);
				}
				return false;
			}
			return response.status === NO_CONTENT;
		});
	}
}

export const NOT_ENROLLED = 'NOT_ENROLLED' as const;
export const ENROLLED = 'ENROLLED' as const;
export type EnrollmentStatus = typeof NOT_ENROLLED | typeof ENROLLED | undefined;

// @ts-expect-error - TS2322 - Type '(messageId: string) => { enrollmentStatus: unknown; stopChangeboarding: () => void; }' is not assignable to type '(messageId: string) => { enrollmentStatus: EnrollmentStatus; stopChangeboarding: () => void; }'.
export const useChangeboardingState: (messageId: string) => {
	enrollmentStatus: EnrollmentStatus;
	stopChangeboarding: () => void;
} = (messageId: string) => {
	const { cloudId } = useTenantContext();
	const { data: orgId } = useOrgId();
	const [enrollmentStatus, setEnrollmentStatus] = useState<unknown>();
	const client = useMemo(
		() => new CustomCoordinationClient(cloudId, '/gateway/api', orgId || ''),
		[cloudId, orgId],
	);
	const startChangeboarding = useCallback(async () => {
		const started = await client.start(messageId);
		if (!started) {
			if (client.notEnrolledMessages.includes(messageId)) {
				setEnrollmentStatus(NOT_ENROLLED);
			}
		} else {
			setEnrollmentStatus(ENROLLED);
		}
	}, [client, messageId]);
	useEffect(() => {
		startChangeboarding();
	}, [startChangeboarding]);

	return {
		enrollmentStatus,
		stopChangeboarding: () => {
			client.stop(messageId);
		},
	};
};
